<div class="p-3">
  <textarea
    [formControl]="textControl"
    class="w-full p-4 rounded-lg shadow-md bg-white border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none min-h-[150px] max-w-[440px]"
    placeholder="Comentario para el establecimiento..."
  >
  </textarea>
</div>
